import Cookies from "universal-cookie"
import * as cookieNames from "../booking/constants/Cookies"

const cookies = new Cookies()

export const getCookie = (name) => {
  return cookies.get(name)
}

export const setCookie = (name, value) => {
  cookies.set(name, value, { path: "/" })
}

export const setCookieWithExpiration = (name, value, date) => {
  cookies.set(name, value, { expires: new Date(date), path: "/" })
}

export const removeCookie = (name) => {
  cookies.remove(name)
}

export const deleteCookie = (name) => {
  cookies.set(name, undefined, { expires: new Date(1700, 1, 1), path: "/" })
}

export const getUserId = (props) => {
  var userId
  if (props && props.cookies) {
    userId = props.cookies.get(cookieNames.IDP_USER_ID)
    if (userId) {
      return userId
    }
    userId = props.cookies.get(cookieNames.CPH_TEMP_USER)
    if (userId) {
      return userId
    }
  }

  userId = getCookie(cookieNames.IDP_USER_ID)
  if (userId) {
    return userId
  }
  userId = getCookie(cookieNames.CPH_TEMP_USER)
  if (userId) {
    return userId
  }
  return userId
}

export const isLoggedIn = () => {
  const cookieToken = getCookie(cookieNames.ACCESS_TOKEN)
  return !!cookieToken
}
